import styled, {css} from 'styled-components'
import {InputText} from '@components/commons/input-text/InputText.tsx'

export const SearchInput = styled(InputText)`
    ${({theme}) => css`
        max-width: 688px;
        & div {
            border-radius: 28px;
            padding: 0 ${theme.spacing * 3}px;
            transition: border 0.3s ease-in-out;
            &:has(input:focus) {
                border-color: ${theme.palette.primary['500']};
            }

            & input {
                margin: 0 ${theme.spacing * 2}px;
                outline: none;
                box-shadow: none;
            }

            @media (max-width: 768px) {
                padding: 0 8px 0 0;
                border-radius: 8px;
            }
        }
    `}
`

export const SearchButton = styled.div`
    ${() => css`
        display: block;
    `}
`
